<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      consultas: null,
    };
  },
  methods: {
    getConsultas() {
      this.consultas = null;

      api
        .get('telemedicina/consultas')
        .then((response) => {
          if (response.data.status == 'success') {
            this.consultas = response.data.list;
          }
        })
    },
  },
  mounted() {
    this.getConsultas();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/seguros">Seguros</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Assistência Funeral</h3>
        <p></p>
      </div>
    </div>

    <h5 class="mb-4">Coberturas</h5>

    <div class="card">
      <div class="card-body">
        <div class="border-bottom pt-2 pb-4">
          <h5 class="font-size-15 m-0">Um Semi Luxo - Sepultamento de membros amputados no valor de R$ 1.200,00</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">Ornamentação Completa - Comunicado em Jornal</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">2 Coroas de Flores - Cremação</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">Capela - 24h - Embalamento/Tanatopraxia</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">Carro Fúnebre - Translado Nacional e Internacional, limitado a 1000KM</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">Cuidados (vestimenta e maquiagem) - Transporte de um membro da família para liberação do corpo</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">Documentação e registro em cartório - Hospedagem (3 diárias) para um membro da família para liberação do corpo</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">Higienização - Disponibilização de café e água no velório</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">Liberação do Corpo em IML ou hospitais - Transporte terrestre para até 4 membros da família do domicílio até o local de sepultamento, limitado a 100KM</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">Livro de Presença - Placa com nome da Lápide</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">Pagamento de taxas de sepultamento e exumação - Véu e manta mortuária</h5>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15 m-0">Sepultamento (aluguel - 3 anos)</h5>
        </div>
        <div class="pt-2">
          <a href="https://wa.me/552135147535" target="_blank" class="btn btn-outline-default btn-block mt-3">
            Acionar Assistência
          </a>
        </div>
      </div>
    </div>
  </Layout>
</template>